import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import ProjectPage from './pages/ProjectPage';
import AdminLogin from './pages/AdminLogin';
import AdminHome from './pages/AdminHome';
import AdminProjectEditor from './pages/AdminProjectEditor';
import RequireAuth from './components/RequireAuth';

function App() {
  return (
    <Routes>
      {/* Public routes with nav + footer */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:id" element={<ProjectPage />} />
      </Route>

      {/* Auth */}
      <Route path="/adminlogin" element={<AdminLogin />} />

      {/* Protected admin routes (no shared layout — admin has its own header) */}
      <Route element={<RequireAuth />}>
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/projects/new" element={<AdminProjectEditor />} />
        <Route path="/admin/projects/:id" element={<AdminProjectEditor />} />
      </Route>
    </Routes>
  );
}

export default App;
